import { useDelete, useList, useNavigation } from "@refinedev/core";
import { Button, Popconfirm, Space, Table, message } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { List, ShowButton, TextField } from "@refinedev/antd";
import { AppTitle } from "components";
import { MedicineContestType, MedicineContestYear } from "./types";

type MedicineContestYearsProps = {
  contestType?: MedicineContestType;
  basePath?: string;
  title?: string;
  createButtonText?: string;
  openSingleItem?: boolean;
};

export const MedicineContestYears = ({
  contestType = "CONTEST",
  basePath = "/medicine/contests",
  title,
  createButtonText,
  openSingleItem = false,
}: MedicineContestYearsProps) => {
  const { push } = useNavigation();
  const pageTitle =
    title || (contestType === "CONFERENCE" ? "Конференции" : "Конкурс");
  const buttonText =
    createButtonText ||
    (contestType === "CONFERENCE" ? "Создать конференцию" : "Создать конкурс");

  const { data, isLoading, refetch } = useList<MedicineContestYear>({
    resource: openSingleItem
      ? "medicine-contest-years-with-items"
      : "medicine-contest-years",
    dataProviderName: "medicineContestsDataProvider",
    meta: {
      contestType,
    },
  });
  const { mutate: deleteContest, isLoading: deletingContest } = useDelete();

  const years = data?.data || [];
  const getYearPath = (record: MedicineContestYear) => {
    if (openSingleItem) {
      return record.contest?.id
        ? `${basePath}/${record.year}/edit/${record.contest.id}`
        : `${basePath}/${record.year}/create`;
    }

    return `${basePath}/${record.year}`;
  };
  const handleDelete = (record: MedicineContestYear) => {
    if (!record.contest?.id) {
      return;
    }

    deleteContest(
      {
        dataProviderName: "medicineContestsDataProvider",
        resource: "medicine-contests",
        id: record.contest.id,
        meta: {
          contestType,
        },
      },
      {
        onSuccess: () => {
          message.success(
            contestType === "CONFERENCE"
              ? "Конференция удалена"
              : "Конкурс удален"
          );
          refetch();
        },
        onError: (error: any) => {
          message.error(error?.message || "Не удалось удалить запись");
        },
      }
    );
  };

  return (
    <List
      title={<AppTitle canGoBack>{pageTitle}</AppTitle>}
      resource="medicine-contest-years"
      breadcrumb={false}
      canCreate={false}
      headerButtons={
        <Space>
          {contestType === "CONFERENCE" && (
            <Button onClick={() => push(`${basePath}/page`)}>Страница</Button>
          )}
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => push(`${basePath}/create`)}
          >
            {buttonText}
          </Button>
        </Space>
      }
    >
      <Table<MedicineContestYear>
        dataSource={years}
        loading={isLoading}
        rowKey="id"
        pagination={false}
        locale={{
          emptyText: <div style={{ margin: 56 }}>Данные отстутствуют</div>,
        }}
      >
        <Table.Column<MedicineContestYear>
          dataIndex="year"
          key="year"
          title="Год"
          render={(value) => <TextField value={value} />}
        />
        <Table.Column<MedicineContestYear>
          width={260}
          fixed="right"
          key="actions"
          title="Действия"
          render={(_, record) => (
            <Space size={8} direction="vertical" style={{ width: "100%" }}>
              <ShowButton
                onClick={() => push(getYearPath(record))}
                size="small"
                block
              >
                Смотреть / редактировать
              </ShowButton>
              {openSingleItem && record.contest?.id && (
                <Popconfirm
                  title="Удалить запись?"
                  okText="Удалить"
                  cancelText="Отмена"
                  onConfirm={() => handleDelete(record)}
                >
                  <Button
                    danger
                    size="small"
                    icon={<DeleteOutlined />}
                    loading={deletingContest}
                    block
                  >
                    Удалить
                  </Button>
                </Popconfirm>
              )}
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
